module.exports = __webpack_public_path__ + "img/whatsapp.5ae1bc62.png";